export enum QuestionDetailFilterTypes {
    Like = "like",
    Dislike="dislike",
    NoAction="noaction",
    Country =  "country",
    Duration = "duration",
    Documents = "documentGuids"
}
